"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.entitiesArrayToObject = exports.arrayToMap = void 0;
function arrayToMap(array, key) {
    const map = new Map();
    array.forEach((item) => map.set(item[key], item));
    return map;
}
exports.arrayToMap = arrayToMap;
function entitiesArrayToObject(array) {
    const obj = {};
    array.forEach((entity) => (obj[entity.id] = entity));
    return obj;
}
exports.entitiesArrayToObject = entitiesArrayToObject;
